/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const GET_PROCUREMENT_RELEASE_URL = `${API_URL}/procurementrelease`;
